import React, { Fragment } from 'react';

import { ListItem, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { styles } from 'theme/nav-link-theme';
import { CustomNavLink } from 'utils/redirect-utils';

const permissionValid = (rightsList, permissions) =>
  permissions.filter(
    permission =>
      rightsList.filter(
        right => (right.action ? right.action === permission : right === permission),
      ).length > 0,
  ).length > 0;

const NavLinkListItem = ({ classes, list = [], name }) => (
  <>
    {list.map(({ component, key, permissions, rightsList, url, label, icon, other }) => {
      const uniqueKey = `${name}-${key}`;

      if (rightsList?.length && permissions) {
        if (!permissionValid(rightsList, permissions)) return null;
      }
      if (component) {
        const element = React.isValidElement(component)
          ? component
          : React.createElement(component);
        if (rightsList?.length && permissions) {
          if (permissionValid(rightsList, permissions)) return element;
          return null;
        }
        return <Fragment key={uniqueKey}>{element}</Fragment>;
      }
      return (
        <ListItem
          key={uniqueKey}
          button
          classes={{
            root: classes.listItem,
          }}
          to={url}
          activeClassName={classes.active}
          component={CustomNavLink}
        >
          {React.isValidElement(icon)
            ? icon
            : typeof icon === 'function'
              ? React.createElement(icon)
              : null}
          <Typography noWrap variant="body">
            {typeof label === 'function' ? null : label}
          </Typography>
          {React.isValidElement(other)
            ? other
            : typeof other === 'function'
              ? React.createElement(other)
              : other}
        </ListItem>
      );
    })}
  </>
);

NavLinkListItem.propTypes = {
  classes: PropTypes.object.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      key: PropTypes.string,
      url: PropTypes.string,
      icon: PropTypes.node,
      component: PropTypes.any,
      other: PropTypes.node,
    }),
  ),
  name: PropTypes.string,
};

export default compose(withStyles(styles))(NavLinkListItem);
